import { render, staticRenderFns } from "./EdiEnvelopes.vue?vue&type=template&id=845c956e"
import script from "./EdiEnvelopes.vue?vue&type=script&lang=js"
export * from "./EdiEnvelopes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports